<template>
	<!-- 评审基本信息 -->
	<div class="review-base-info">
		<el-form :model="addReviewForm" :rules="addReviewFormRules" ref="addReviewFormRef" label-width="120px" class="demo-ruleForm">
		  <el-form-item label="评审名称" prop="name">
		    <el-input v-model="addReviewForm.name"></el-input>
		  </el-form-item>
			<el-form-item label="评审方式" prop="reviewWay">
			  <el-radio-group v-model="addReviewForm.reviewWay">
			      <el-radio :label="0" :disabled="this.projectData.anonymousReviewState==0">匿名评审</el-radio>
			      <el-radio :label="1">非匿名评审</el-radio>
			    </el-radio-group>
			</el-form-item>
			<el-form-item label="评价类别" prop="reviewType">
			  <el-radio-group v-model="addReviewForm.reviewType" :disabled="addReviewForm.reviewState!=1">
			      <el-radio :label="0">初评</el-radio>
			      <el-radio :label="1">复评</el-radio>
			      <el-radio :label="2">终评</el-radio>
			    </el-radio-group>
			</el-form-item>
			<el-form-item label="评语" prop="evaluationWay">
				<el-radio-group v-model="addReviewForm.evaluationWay">
				    <el-radio :label="0">不必填</el-radio>
				    <el-radio :label="1">必填</el-radio>
				  </el-radio-group>
			</el-form-item>
			<!-- <el-form-item label="评审开始日期" prop="reviewStartTime">
			  <el-date-picker
			  	v-model="addReviewForm.reviewStartTime"
			  	:picker-options="pickerOptions"
			  	type="date"
			  	value-format="yyyy-MM-dd HH:mm:ss"
			  	format="yyyy-MM-dd"
			  	placeholder="选择日期"
			  ></el-date-picker>
			</el-form-item> -->
			<el-form-item label="评审截止日期" prop="reviewEndTime">
			  <el-date-picker
			  	v-model="addReviewForm.reviewEndTime"
			  	:picker-options="pickerOptions"
			  	type="date"
			  	value-format="yyyy-MM-dd HH:mm:ss"
			  	format="yyyy-MM-dd"
			  	placeholder="选择日期"
			  ></el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="baseInfoSave" v-if="[1,6].includes(addReviewForm.reviewState)">保存并下一步</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	import { addReviewBaseInfo,getReviewBaseInfoById,editBaseInfoAgain } from '@/api/after/expertReviewSettings';
	export default {
		data(){
			return {
				addReviewForm:{
					name:'',//	评审名称
					reviewWay:'',//评审方式(0:匿名评审,1:非匿名评审)
					reviewType:'',//评审类型(0:初评,1:复评,2::终评)
					evaluationWay:'',//评语方式(0:不必填,1:必填)
					reviewEndTime:'',//评审截止日期
					reviewStartTime:'',//评审开始日期
				},
				addReviewFormRules:{
					name:[{ required: true, message: '请输入评审名称', trigger: 'blur' }],
					reviewWay:[{ required: true, message: '请选择评审方式', trigger: 'change' }],
					reviewType:[{ required: true, message: '请选择评审类型', trigger: 'change' }],
					evaluationWay:[{ required: true, message: '请选择评语', trigger: 'change' }],
					reviewEndTime:[{ required: true, message: '请选择评审截止日期', trigger: 'change' }],
					// reviewStartTime:[{ required: true, message: '请选择评审开始日期', trigger: 'change' }],
				},
				projectData:JSON.parse(sessionStorage.getItem('projectData')),
				pickerOptions:{
					disabledDate(time) {
						return time.getTime() < Date.now()
					},
				},
			}
		},
		created() {
			if (!this.projectData) {
				this.$message.error('参数错误！')
				this.$router.go(-1);
				return
			}
			if (this.$route.query.reviewId) {
				// 获取审核基本信息
				this.getReviewBaseInfoById(this.$route.query.reviewId)
			}
		},
		methods:{
			// 修改评审
			async addReviewBaseInfo(){
				const res = await addReviewBaseInfo(this.addReviewForm)
				if (res.code == 200) {
					console.log('修改基本信息',res);
					this.$emit('edited')
				}else{
					this.$message.error(res.data)
				}
			},
			// 基本信息保存并下一步
			baseInfoSave(){
				this.$refs.addReviewFormRef.validate(async (valid) => {
					if (valid) {
						this.addReviewForm.id = this.$route.query.reviewId
						if (this.addReviewForm.reviewState==1) {
							this.addReviewBaseInfo()
						}else if(this.addReviewForm.reviewState==6){
							const res = await editBaseInfoAgain(this.addReviewForm)
							if (res.code == 200) {
								this.$message.success('编辑成功！')
							}else{
								this.$message.error(res.data)
							}
						}
					}else{
						this.$message.error('表单验证失败！')
					}
				})
			},
			getNowFormatDate() {
				var date = new Date();
				var seperator1 = "-";
				var year = date.getFullYear();
				var month = date.getMonth() + 1;
				var strDate = date.getDate();
				if (month >= 1 && month <= 9) {
					month = "0" + month;
				}
				if (strDate >= 0 && strDate <= 9) {
					strDate = "0" + strDate;
				}
				var currentdate = year + seperator1 + month + seperator1 + strDate;
				currentdate =currentdate+' 00:00:00';
				return currentdate;
			},
			// 根据评审ID获取评审基本信息
			async getReviewBaseInfoById(id){
				const res = await getReviewBaseInfoById(id)
				if (res.code==200) {
					// console.log('111评审基本信息',res);
					this.addReviewForm = res.data
				}else{
					this.$message.error(res.data)
				}
			},
		}
	}
</script>

<style scoped>

</style>